export const ASYNC_FETCH = 'ILD_Remarks/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESSPLAN = 'ILD_Remarks/ASYNC_FETCH_SUCCESSPLAN';
export const ASYNC_FETCH_FAILURE = 'ITD_Remarks/ASYNC_FETCH_FAILURE';
export const SET_SELECTED_REMARK = 'ILD_GenerateRemarks/SET_SELECTED_REMARK';
export const SET_ISREMARKS_LOAD = 'ILD_Remarks/SET_ISREMARKS_LOAD';
export const SET_ISREDIRECT_TO_HUB = 'ILD_Remarks/SET_ISREDIRECT_TO_HUB';


